import { useCallback } from 'react'
import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import { ConfirmDialog } from 'civic-champs-shared/core/confirm-dialog/'
import { useRemoveQuestionnaire } from './useRemoveQuestionnaire'

export const useRemoveQuestionnairePrompt = (eagerRemove: any) => {
  const showPrompt = useShowPrompt(ConfirmDialog)
  const removeQuestionnaire = useRemoveQuestionnaire(eagerRemove)

  return useCallback(
    async questionnaire => {
      const text = `Are you sure you want to delete "${questionnaire.name}"? The action can not be undone.`
      const confirmed = await showPrompt({
        text,
        title: 'Confirm Action',
        confirmText: 'Delete',
        cancelText: 'Cancel',
        type: 'warning',
      })

      if (confirmed) {
        await removeQuestionnaire(questionnaire)
      }
    },
    [showPrompt, removeQuestionnaire],
  )
}

export default useRemoveQuestionnairePrompt
